module.exports = __webpack_public_path__ + "img/20180815_151844_215.b4abdf0f.jpg";